/*
 * @Descripttion:
 * @Author: voanit
 * @Date: 2021-07-08 17:51:33
 * @LastEditors: voanit
 * @LastEditTime: 2021-12-08 18:07:15
 */
import Cookies from 'js-cookie'
import moment from 'moment'
import { _local, getSession } from '@/utils/storage'
import { autoBind } from '@/server/shopList'
import {
  deepClone,
} from '@/utils';
import { getComboStatus, getWatermark } from '@/server/user'
import { listToTree } from '@/utils/index';
import { menuMap } from '@/lib/menuFormat';
import {
  getAuthorityMenu,
} from '@/server/common';
import { UpdateUserInfoConfig } from '@/server/personal/contract'
export default {
  state: {
    info: {},
    hasBindData: null,
    // userInfo: Cookies.get('saasUser') || null,
    userId: _local.get('userId') || null,
    userName: _local.get('userName') || '未知用户',
    merchantList: _local.get('merchantList') || [],
    merchantId: _local.get('merchantId') || '',
    currency: '$',
    authorityList: _local.get('AuthList') || [],
    systemStatus: '',
    ownerMerchant: null, // 判断当前商家的套餐是否过期
    sourceType: null, // 1：超店BI，2：ERP
    isExpired: false,
    authority: false,
    onloadIframe: false,
    combo: {},
    watermark: {}
  },
  getters: {
    getIsOwnMerchant(state) {
      return state.ownerMerchant == state.userId
    }
  },
  mutations: {
    'user.setIsExpired'(state, data) {
      state.isExpired = data
    },
    'user.setAuthority'(state, data) {
      state.authority = data
    },
    'user.setMerchantList'(state, data) {
      state.merchantList = data
      // 获取当前商家的所有信息
      let a = data.filter(el => el.userId == state.merchantId)
      if (a.length) {
        console.log(a)
        // 设置当前商家的归属userID
        state.ownerMerchant = a[0].ownerId
        state.sourceType = a[0].sourceType
      }
      console.log(a, 'setList');
    },
    'user.setMerchantId'(state, data) {
      _local.set('merchantId', data)
      let a = state.merchantList.filter(el => el.userId == data)
      if (a.length) {
        state.ownerMerchant = a[0].ownerId
        state.sourceType = a[0].sourceType
      }
      console.log(a, 'setID');
      state.merchantId = data
    },
    'user.sethasBindData'(state, data) {
      state.hasBindData = state.hasBindData ? Object.assign(state.hasBindData, data) : data
    },
    'user.setValue'(state, payload) {
      state[payload.key] = payload.value
    },
    'user.setOrigin'(state, data) {
      state.origin = data
    },
    'user.setUserName'(state, data) {
      state.userName = _local.get('userName') || '未知用户'
    },
    'user.setAuthorityList'(state, data) {
      state.authorityList = data
    },
    setSiteList(state, data) {
      state.info.siteList = data
    },
    'user.setSystemStatus'(state, data) {
      state.systemStatus = data
    },
    'user.setCombo'(state, data) {
      state.combo = data
    },
    'user.watermark'(state, data) {
      state.watermark = data
    },
    'user.onloadIframe'(state, data) {
      state.onloadIframe = data
    }

  },
  actions: {
    async getUserAuth(store, update) {
      if (_local.get('AuthList') && !update) {
        let menu = menuMap(_local.get('AuthList'))
        store.commit('user.setAuthorityList', menu)
        store.commit('menu.setMenus', listToTree(deepClone(menu), 4, 1))
      } else {
        if (_local.get('merchantId')) {
          const res = await getAuthorityMenu(_local.get('merchantId'));
          if (res.data.code === 0) {
            const menu = menuMap(res.data.data);
            _local.set('AuthList', res.data.data)
            store.commit('user.setAuthorityList', menu);
            store.commit('menu.setMenus', listToTree(deepClone(menu)));

          }
        }

      }

    },
    async getCombo(store, systemId) {
      // if (_local.get('Combo') && systemId != 6) {
      //   let data = _local.get('Combo')
      //   if (data.data.comboExpireDate) {
      //     data.data.comboExpireDateTime = moment(data.data.comboExpireDate).format('YYYY-MM-DD HH:mm:ss')
      //   }
      //   store.commit('user.setCombo', data.data);
      //   if (!data.data.isThird) {
      //     store.commit('user.setIsExpired', data.data.isExpire)
      //   }
      // } else {
      const { data } = await getComboStatus({
        systemId: systemId || 3,
        userId: _local.get('userId')
      })
      if (data.code === 0) {
        // _local.set('Combo', data)
        if (data.data.comboExpireDate) {
          data.data.comboExpireDateTime = moment(data.data.comboExpireDate).format('YYYY-MM-DD HH:mm:ss')
        }
        store.commit('user.setCombo', data.data);
        if (!data.data.isThird) {
          store.commit('user.setIsExpired', data.data.isExpire)
        }
      }
    },
    async autoBindQue(store, systemId) {
      if (!_local.get('autoBind')) {
        const res = await autoBind()
        if (res.data.code == 0) {
          _local.set('autoBind', res)
        }
      }
      // }
    },
    async getWatermark(store) {
      const { data } = await getWatermark()
      if (data.code === 0) {
        const defaultForm = {
          status: 0,
          userName: true,
          text: store.state.userName,
          fontSize: 14,
          color: '#010517',
          opacity: 10
        }
        if (data.data) {
          const form = data.data.value ? JSON.parse(data.data.value) : defaultForm
          store.commit('user.watermark', { ...form, status: Number(data.data.status) })
        }
      }
    },
    // 更新配置
    async updateUserInfoConfig(store, params) {
      const { data } = await UpdateUserInfoConfig({ config: JSON.stringify(params) })
      if (data.code === 0) {
        _local.set('report_local', params)
      }
    }
  }
}
